<div class="account-menu__header">
  <span class="account-menu__avatar" aria-hidden="true">{{ userInitials }}</span>
  <div class="account-menu__identity">
    <span class="account-menu__name">{{ userService.currentUser?.name }}</span>
    <span class="account-menu__email">{{ userService.currentUser?.email }}</span>
  </div>
  <button matIconButton
    aria-label="Close account menu"
    (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- The current page's item takes Material's activated state: the M3 active-indicator fill,
and the aria-current="page" MatListItem sets from it. An [attr.aria-current] binding here would
be overwritten by MatListItem's own host binding. -->
<mat-nav-list class="navigation" role="list" aria-label="Account navigation">
  @if (linkedAccountsEnabled) {
    <a mat-list-item
      class="navigation-link"
      routerLink="/profile/linked-accounts"
      [activated]="appService.currentPage('/profile/linked-accounts')">
      <mat-icon matListItemIcon>hub</mat-icon>
      <span matListItemTitle>
        {{ siteMetadataService.term(linkedAccountTermName).plural }}
      </span>
    </a>
  }

  <a mat-list-item
    class="navigation-link"
    routerLink="/profile/personal-info"
    [activated]="appService.currentPage('/profile/personal-info')">
    <mat-icon matListItemIcon>person</mat-icon>
    <span matListItemTitle>Personal info</span>
  </a>

  <a mat-list-item
    class="navigation-link"
    routerLink="/profile/notification-settings"
    [activated]="appService.currentPage('/profile/notification-settings')">
    <mat-icon matListItemIcon>notifications</mat-icon>
    <span matListItemTitle>Notification settings</span>
  </a>

  <a mat-list-item
    class="navigation-link"
    routerLink="/profile/change-password"
    [activated]="appService.currentPage('/profile/change-password')">
    <mat-icon matListItemIcon>lock</mat-icon>
    <span matListItemTitle>Change password</span>
  </a>

  @if (canSavePaymentMethod) {
    <a mat-list-item
      class="navigation-link"
      routerLink="/profile/payment-methods"
      [activated]="appService.currentPage('/profile/payment-methods')">
      <mat-icon matListItemIcon>account_balance_wallet</mat-icon>
      <span matListItemTitle>Payment methods</span>
    </a>
  }

  <a mat-list-item
    class="navigation-link"
    routerLink="/profile/payment-history"
    [activated]="appService.currentPage('/profile/payment-history')">
    <mat-icon matListItemIcon>receipt_long</mat-icon>
    <span matListItemTitle>{{ scheduledPaymentsEnabled ? 'Payments' : 'Payment History' }}</span>
  </a>

  @if (scheduledPaymentsEnabled) {
    <a mat-list-item
      class="navigation-link"
      routerLink="/profile/schedules"
      [activated]="appService.currentPage('/profile/schedules')">
      <mat-icon matListItemIcon>calendar_today</mat-icon>
      <span matListItemTitle>Schedules</span>
    </a>
  }
</mat-nav-list>

<mat-divider></mat-divider>

<mat-action-list class="action-list">
  <button mat-list-item
    class="action-link"
    (click)="onClick_signOut()">
    <mat-icon matListItemIcon>logout</mat-icon>
    <span matListItemTitle>Sign out</span>
  </button>
</mat-action-list>
